import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(path, params, filename) {
  const r = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const fileUrl = (path) =>
  path ? `${API}/files/${path}?auth=${localStorage.getItem("token")}` : null;

export const openPdf = async (path, filename) => {
  const res = await api.get(path, { responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) { const a = document.createElement("a"); a.href = url; a.download = filename || "dokumen.pdf"; a.click(); }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const fmtIDR = (n) => "Rp " + (Number(n) || 0).toLocaleString("id-ID");

// Tanggal WIB (Asia/Jakarta) dalam format YYYY-MM-DD untuk default filter laporan.
export const wibDateISO = (d = new Date()) =>
  d.toLocaleDateString("en-CA", { timeZone: "Asia/Jakarta" });
export const wibDaysAgo = (n) =>
  wibDateISO(new Date(Date.now() - n * 864e5));

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
      timeZone: "Asia/Jakarta",
    }) + " WIB";
  } catch { return iso; }
};

export const fmtDateShort = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Jakarta" });
  } catch { return iso; }
};
